import { render } from "./Padder.vue?vue&type=template&id=9c9069b8&scoped=true"
import script from "./Padder.vue?vue&type=script&lang=js"
export * from "./Padder.vue?vue&type=script&lang=js"

import "./Padder.vue?vue&type=style&index=0&id=9c9069b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9069b8"]])

export default __exports__